// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {useRandom} from 'docs/data';
import './ContentSkeleton.scss';

const NUMBER_OF_PARAGRAPHS = 2;

type ParagraphProps = {|
  wordWidths: Array<number>,
|};

const Paragraph = ({wordWidths}: ParagraphProps) => (
  <Box margin={{bottom: 24}}>
    {wordWidths.map((width, index) => (
      <Word key={index} height={18} width={width} />
    ))}
  </Box>
);

type WordProps = {|
  height: number,
  width: number,
|};

const Word = ({height, width}: WordProps) => (
  <Box
    background="surface"
    margin={{bottom: 8}}
    style={{display: 'inline-block', height: `${height}px`, width}}
  />
);

export const ContentSkeleton = () => {
  const {generateRandomInteger} = useRandom();

  const headerWidth = generateRandomInteger(450, 600);
  const subheaderWidth = generateRandomInteger(600, 750);

  const generateParagraphWordCount = () => generateRandomInteger(20, 30);
  const generateWordWidth = () => generateRandomInteger(40, 160);
  const paragraphs = [...Array(NUMBER_OF_PARAGRAPHS)].map(() => {
    return [...Array(generateParagraphWordCount())].map(generateWordWidth);
  });

  return (
    <div className="ContentSkeleton">
      <Box
        background="surface"
        margin={{top: 8}}
        style={{width: `${headerWidth}px`, height: '42px'}}
        className="ContentSkeleton-header"
      />
      <Box
        background="surface"
        margin={{top: 12, bottom: 48}}
        style={{width: `${subheaderWidth}px`, height: '28px'}}
        className="ContentSkeleton-subheader"
      />
      {paragraphs.map((wordWidths, index) => (
        <Paragraph key={index} wordWidths={wordWidths} />
      ))}
      <div className="ContentSkeleton-overlay" />
    </div>
  );
};
